import { ModalContext } from '@/contexts/ModalProvider';
import { useTranslations } from 'next-intl';
import { useState, useEffect, useContext } from 'react';

export function OnlineStatusHandler() {
  const [isOnline, setIsOnline] = useState(true);
  const { openActionModal, close } = useContext(ModalContext);
  const t = useTranslations();

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);

      // Maybe add for when they come back online?
      close();
    };
    const handleOffline = () => {
      setIsOnline(false);
      openActionModal({
        closeOnOuterClick: true,
        hasCenteredText: true,
        title: t('common.error_modal.offline.title'),
        text: t('common.error_modal.offline.text'),
        img: {
          ariaLabel: 'This is a happy orange image',
          size: 'large',
          url: `/assets/wave-grocery/HappyOrange.png`,
        },
        actions: [
          {
            btnLabel: t('common.guest_address.unsuported.close'),
            onClick: () => close(),
            variant: 'filled',
          },
        ],
      });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return <></>;
}
